module.exports = __webpack_public_path__ + "static/img/icon_w.8d9879e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/icon_w.png
// module id = 651
// module chunks = 2